var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"missing block content"},[_c('p',{staticClass:"mb-4"},[_vm._v("Any missing extracts for this day will appear in this section.")]),_c('div',{staticClass:"modern-grid"},_vm._l((_vm.componentsList),function(component){return _c(component.comp,{key:component.name,tag:"component",attrs:{"scanResults":_vm.scanResults}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }